import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import moment from 'moment';
import { Duration } from 'moment/moment';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
   name: 'singleUnitDurationToText$',
})
export class SingleUnitDurationToTextPipe implements PipeTransform {
   transform(inputValue: Duration | number | Observable<Duration> | Observable<number>): Observable<string> {
      const duration$ = isObservable(inputValue) ? inputValue : of(inputValue);

      return duration$.pipe(
         map((x) => {
            if (!_.isNumber(x)) {
               return x;
            }
            return moment.duration(x, 'ms');
         }),
         map((waitingDuration) => {
            if (waitingDuration.asMilliseconds() < 0) {
               return '';
            }
            const waitingYears = waitingDuration.years();
            const waitingMonths = waitingDuration.months();
            const waitingDays = waitingDuration.days();
            const waitingHours = waitingDuration.hours();
            const waitingMinutes = waitingDuration.minutes();

            if (waitingYears > 0) {
               return `${waitingYears}`;
            } else if (waitingMonths > 0) {
               return `${waitingMonths}`;
            } else if (waitingDays > 0) {
               return `${waitingDays}`;
            } else if (waitingHours > 0) {
               return `${waitingHours}`;
            } else if (waitingMinutes > 0) {
               return `${waitingMinutes}`;
            }
            return '';
         })
      );
   }
}
